const CAP_BITCOIN_ANONIMATO = {
  title: "¿Bitcoin es anónimo?",
  sections: [
    {
      heading: "Bitcoin ¿es anónimo?",
      text: [
        "Existe la creencia de que Bitcoin es una forma de dinero completamente anónima, pero esto es falso. En realidad Bitcoin es seudónimo, lo que significa que no muestra nombres ni identidad real, pero sí muestra direcciones públicas, cantidad, fecha y movimientos registrados permanentemente."
      ]
    },
    {
      heading: "Anonimato vs Privacidad",
      text: ["Es importante diferenciar estos conceptos:"],
      list: [
        "Anonimato: terceros no conocen quién envía ni quién recibe.",
        "Privacidad: terceros no conocen cuánto se envió, cuándo ni con qué propósito."
      ],
      textAfter: [
        "Bitcoin no protege totalmente ninguno de los dos conceptos, aunque ofrece cierto nivel de privacidad, no garantiza anonimato real."
      ]
    },
    {
      heading: "¿Qué datos expone Bitcoin?",
      text: [
        "Bitcoin permite crear billeteras sin nombre, sin email y sin registro. Pero su funcionamiento depende de un libro de contabilidad público llamado Blockchain, donde todas las transacciones quedan registradas para siempre.",
        "Se puede ver en tiempo real cualquier transacción desde 2009 hasta la última.",
        "¿Qué información aparece en la Blockchain?"
      ],
      list: [
        "Identificador único (hash) de la transacción",
        "Dirección de origen (pública)",
        "Direcciones de destino",
        "Monto transferido",
        "Fecha y hora",
        "Tarifa pagada al minero"
      ],
      textAfter: [
        "A simple vista estos datos no muestran identidad real, pero pueden ser analizados para relacionarlos con personas."
      ]
    },
    {
      heading: "Imagen ejemplo de transacción",
      image: {
        src: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesBooks/refs/heads/main/imagesFundamentosBlockchain/Biucoinmaster/informacion_transaccion.png",
        caption: "Un identificador único (1), una dirección bitcoin de origen (2), varios destinatarios (3), cantidades y fechas. ¿Dónde dice quién soy? En principio, en ningún lado."
      }
    },
    {
      heading: "¿Se puede rastrear una transacción?",
      text: [
        "Sí. Aunque Bitcoin no muestre nombres, existen herramientas y empresas que analizan direcciones y patrones para vincularlas con personas o empresas.",
        "Casos que revelan identidad fácilmente incluyen:"
      ],
      list: [
        "Comprar Bitcoin en exchanges con KYC",
        "Usar la misma dirección muchas veces",
        "Relacionar una dirección con un correo, redes sociales o envíos",
        "Hacer compras físicas pagando con Bitcoin"
      ]
    },
    {
      heading: "Conclusión",
      text: [
        "Bitcoin no es completamente anónimo, sino seudónimo. Tiene cierta privacidad, pero todas sus transacciones son públicas y permanentes.",
        "La privacidad debe cuidarse activamente, porque la blockchain no se puede borrar, y en el futuro es probable que se pueda analizar aún más."
      ]
    }
  ]
};

export default CAP_BITCOIN_ANONIMATO;
